import { render, staticRenderFns } from "./OcrData.vue?vue&type=template&id=2841b134&scoped=true&"
import script from "./OcrData.vue?vue&type=script&lang=js&"
export * from "./OcrData.vue?vue&type=script&lang=js&"
import style0 from "./OcrData.vue?vue&type=style&index=0&id=2841b134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841b134",
  null
  
)

export default component.exports